import styled, {css} from 'styled-components';

const getSize = ({viewport}) => {
  switch (viewport) {
    case 'xs':
      return '360px';
    case 'md':
      return '768px';
    case 'lg':
      return '1024px';
    default :
      return '100%';
  }
};
const overflow = ({viewport}) => {
  if (viewport !== 'xl') {
    return 'overflow: auto;';
  }
  return '';
};

const editingCss = ({editing}) => {
  if (!editing) return '';
  return css`
    margin: 0 auto;
    max-width: ${getSize};
    ${overflow};
    border: 1px solid #e1ddec;
    //border-width: 0 1px;
    min-height: calc(100vh - 62px);
    padding: 0 1px;

    background: white;
  `;
};

export const PageWrapper = styled.div`
  ${editingCss}
`;
